const childrenLoaded = require('@alexspirgel/children-loaded');

class ComponentFeaturedPeople extends HTMLDivElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		this.initialize();
	}

	initialize() {

		if (this.initialized) {
			return;
		}
		this.initialized = true;

		const personImageElements = this.querySelectorAll('.component-featured-people__person-image');
		for (const personImageElement of personImageElements) {
			personImageElement.addEventListener('click', this.personImageClickHandler);
		}

	}

	isClickEventNewTab(event) {
		// https://stackoverflow.com/questions/20087368/how-to-detect-if-user-it-trying-to-open-a-link-in-a-new-tab
		if (event.ctrlKey
			|| event.shiftKey
			|| event.metaKey // apple
			|| (event.button && event.button == 1) // middle click, >IE9 + everyone else
		) {
			return true;
		}
		else {
			return false;
		}
	}

	personImageClickHandler = (event) => {
		const personElement = event.target.closest('.component-featured-people__person');
		if (personElement) {
			const personNameLinkElement = personElement.querySelector('.component-featured-people__person-name > a');
			if (personNameLinkElement) {
				if (this.isClickEventNewTab(event)) {
					personNameLinkElement.setAttribute('target', '_blank');
					setTimeout(() => {
						personNameLinkElement.removeAttribute('target');
					}, 100);
				}
				personNameLinkElement.click();
			}
		}
	}

}

customElements.define('component-featured-people', ComponentFeaturedPeople, {extends: 'div'});